// import axios from 'axios';
import { req , tsreq ,reqGet , tsreq1 } from './axiosFun';



// /manager/system 获取门店列表

// 获得门店数据
export const getWarehose =  (params)=>{return  req("get", "/manager/warehouse/getWarehose", params)}

// 获得业务员列表
export const getBussnessUser =  (params)=>{return  req("get", "/manager/warehouse/getBussnessUser", params)}

// 获取区域列表 
export const getRegion =  (params)=>{return  req("get", "/manager/warehouse/getRegion", params)}

// 根据区域获取门店 getWarehoseByRegion
export const getWarehoseByRegion =  (params)=>{return  req("get", "/manager/warehouse/getWarehoseByRegion", params)}

// 根据门店获取业务员 getWarehoseByRegion
export const getUserByWarehouseId =  (params)=>{return  req("get", "/manager/user/getUserByWarehouseId", params)}

//查询进销存管理员用户
export const getJxcAdminUser =  (params)=>{return  req("get", "/manager/user/getJxcAdminUser", params)}

//绑定进销存管理用户
export const bindJxcAdminUser =  (params)=>{return  req("get", "/manager/user/bindJxcAdminUser", params)}

// // 获得业务员列表
// export const getBuss1nessUser =  (params)=>{return  req("get", "/manager/system/getBussnessUser", params)}

// 获得首页数据
export const getIndexStatistics =  (params)=>{return  req("get", "/manager/statistics/getIndexStatistics", params)}
// 获得首页体验订单数据
export const getExperienceOrderStatistics =  (params)=>{return  req("get", "/manager/statistics/getExperienceOrderStatistics", params)}

// getUserExperiencePerformanceExport

export const getWarehouseExperienceSummaryStatistics = (params)=>{return req("get","/manager/experience/getWarehouseExperienceSummaryStatistics",params)}
/**
 * 商品管理------评论
 **/
// 获得评论列表
export const getComment = (params) => { return req("get", "/manager/Comment/commentList", params) };
export const getUserCommentList = (params) => { return req("get", "/manager/Comment/getUserCommentList", params) };

// 增加评论
export const addComment = (params) => { return req("post", "/manager/Comment/addCommentM", params) };
export const addEditComment  = (params) => { return tsreq("post", "/manager/Comment/addCommentM", params) };

// 评论置顶
export const gotopComment= (params) => { return req("post", "/manager/Comment/addCommentM", params) };
// 回复评论
export const updateCommentReply = (params) => { return req("get", "/manager/Comment/updateCommentReply", params) };

// setCommentVisible 设置评论是否隐藏
export const setCommentVisible = (params) => { return req("get", "/manager/Comment/setCommentVisible", params) };


// manager/Comment/getOrderListByGoodsId 根据商品获得订单
export const getOrderListByGoodsId = (params) => { return req("get", "/manager/Comment/getOrderListByGoodsId", params) };

// manager/Comment/getGoodsList 获得商品列表
export const getGoodsList = (params) => { return req("get", "/manager/Comment/getGoodsList", params) };


/**
 * 商品管理------商品列表
 **/

// manager/goods/getAllCategory 获得商品分类
export const getAllCategory = (params) => { return req("get", "/manager/goods/getAllCategory", params) };

// manager/goods/getAllCategory 删除商品分类
export const deleteCategory  = (params) => { return req("get", "/manager/goods/deleteCategory", params) };

// manager/goods/addEditCategory 新增商品分类
export const  addEditCategory  = (params) => { return tsreq("post", "/manager/goods/addEditCategory", params) };

// 获得在售商品getSaleGoods
export const  getSaleGoods  = (params) => { return req("get", "/manager/goods/getSaleGoods", params) };

// 获得活动复制商品
export const  getBaseExperienceGoods  = (params) => { return req("get", "/manager/goods/getActivityBaseExperienceGoods", params) };

// 获得商品分类getGoodsCategory
export const  getGoodsCategory  = (params) => { return req("get", "/manager/goods/getGoodsCategory", params) };

// 获得商品分类新
export const  getGoodsCategoryByParent  = (params) => { return req("get", "/manager/goods/getGoodsCategoryByParent", params) };

// manager/goods/getGoodsList 获得商品列表分页
export const selectGoodsList = (params) => { return req("get", "/manager/goods/selectGoodsList", params) };

// manager/goods/getGoodsById 获得单个商品详情商品列表
export const getGoodsById = (params) => { return req("get", "/manager/goods/getGoodsById", params) };

// manager/goods/addEditGoods 新增修改商品
export const addEditGoods = (params) => { return tsreq("post", "/manager/goods/addEditGoods", params) };

// manager/goods/deleteGoods 删除商品
export const deleteGoods = (params) => { return req("get", "/manager/goods/deleteGoods", params) };

//续年特殊删除规格
export const deleteGoodsSpecsNew = (params) => { return req("get", "/manager/goods/deleteGoodsSpecsNew", params) };

//续年特殊新增修改商品
export const addEditGoodsSpecsNew = (params) => { return tsreq("post", "/manager/goods/addEditGoodsSpecsNew", params) };

//续年特殊获取规格列表
export const getGoodsSpecsNewByGoodsId = (params) => { return req("get", "/manager/goods/getGoodsSpecsNewByGoodsId", params) };

/**
 * 商品管理------banner列表
 **/

// manager/goods/deleteBanner 删除banner、
export const deleteBanner = (params) => { return req("get", "/manager/system/deleteBanner", params) };

// manager/system/getAllBanners 获取所有banner图
export const getAllBanners = (params) => { return req("get", "/manager/system/getAllBanners", params) };

// manager/system/getAllBanners 新增修改banner图
export const addEditBanner = (params) => { return tsreq("post", "/manager/system/addEditBanner", params) };

// 
// 商品管理-根据产品规格来获取参数
export const initGoodsSpecs = (params) => { return req("get", "/manager/goods/initGoodsSpecs", params) };

// 
// 商品管理-获取商品规则分组值
export const getGoodsSpecsGroupVaule = (params) => { return req("get", "/manager/goods/getGoodsSpecsGroupVaule", params) };

// 商品管理-修改商品规则
export const addEditGoodsSpecs = (params) => { return tsreq("post", "/manager/goods/addEditGoodsSpecs", params) };

// 获取所有的共享商品getJxcShareGoodsList
export const getJxcShareGoodsList = (params) => { return req("get", "/manager/goods/getJxcShareGoodsList", params) };

//商品导出
export const goodsQueryExport = (params)=>{return req("get", "/manager/goods/goodsQueryExport",params)}

/**
 * 积分管理
 **/
//获奖名单导出
export const getRewardGoodsExport = (params)=>{return req("get", "/manager/point/getRewardGoodsExport",params)}
// manager/goods/deleteBanner 删除banner、
export const deletePointGoods = (params) => { return req("get", "/manager/goods/deletePointGoods", params) };

//  获取所有的积分商品
export const pointGoodsList = (params) => { return req("get", "/manager/goods/pointGoodsList", params) };

//  新增产品修改
export const savePointGoods = (params) => { return tsreq("post", "/manager/goods/savePointGoods", params) };

// 积分兑换产品详情
export const pointGoodsDetail = (params) => { return tsreq("post", "/manager/goods/pointGoodsDetail", params) };


/**
 * 用户管理
 **/

//  获取会员等级信息
export const getAllVipLevelInfo = (params)=>{return req("get", "/manager/user/getAllVipLevelInfo", params)}

//  获取代理等级信息
export const getAllAgentLevelInfo = (params)=>{return req("get", "/manager/user/getAllAgentLevelInfo", params)}

//  获取所有用户
export const userList = (params)=>{return req("get", "/manager/user/userList", params)}

// 获取用户信息
export const getUserInfo = (params)=>{return req("get", "/manager/user/getUserInfo", params)}

// 设置用户为vipsetUserVip
export const setUserVip = (params)=>{return req("get", "/manager/user/setUserVip", params)}

// 设置用户为业务员
export const setUserBusiness = (params)=>{return req("get", "/manager/user/setUserBusiness", params)}

// 停业务员
export const stopUserBusiness = (params)=>{return req("get", "/manager/user/stopUserBusiness", params)}

// 业务员离职
export const dimissionUserBusiness = (params)=>{return req("get", "/manager/user/dimissionUserBusiness", params)}

// 管理门店
export const setUserManageWarehouse = (params)=>{return req("get", "/manager/user/setUserManageWarehouse", params)}

// 获得门店信息
export const getAllWarehouse = (params)=>{return req("get", "/manager/warehouse/getAllWarehouse", params)}


// 设置用户为代理
export const setUserAgent = (params)=>{return req("get", "/manager/user/setUserAgent", params)}

// 设置用户标签
export const setUserTag = (params)=>{return  req("get", "/manager/user/setUserTag", params)}

// 删除用户标签
export const delUserTag =  (params)=>{return  req("get", "/manager/user/delUserTag", params)}

// 获取所有的用户标签
export const getAllTag = (params)=>{return  req("get", "/manager/user/getAllTag", params)}

// 新增修改标签信息
export const addEditTag = (params)=>{return  tsreq("post", "/manager/user/addEditTag", params)}

// 删除标签信息
export const delTag = (params)=>{return  req("get", "/manager/user/delTag", params)}

/**
 * 订单管理
 **/

// 门店寄存方式，总部发货到门店，门店确认收货
export const getExperienceOrderWarehouseRecevied = (params)=>{return  req("get", "/manager/experience/getExperienceOrderWarehouseRecevied", params)}

// 门店寄存方式，用户从门店领取
export const getExperienceOrderUserRecevied = (params)=>{return  req("get", "/manager/experience/getExperienceOrderUserRecevied", params)}

//门店寄存方式，门店确认样品回收
export const getExperienceOrderWarehouseBackRecevied = (params)=>{return  req("get", "/manager/experience/getExperienceOrderWarehouseBackRecevied", params)}

// 门店寄存方式，门店发货到总部
export const getExperienceOrderWarehouseSend = (params)=>{return  req("get", "/manager/experience/getExperienceOrderWarehouseSend", params)}


// 获取订单详细信息
export const getOrderDetailInfo = (params)=>{return  req("get", "/manager/order/getOrderDetailInfo", params)}

// 获取订单详细信息
export const getOrderList = (params)=>{return  req("get", "/manager/order/getOrderList", params)}

// 导出体验订单信息
export const exportdata = (params)=>{return  req("get", "/manager/order/getOrderListExport", params)}

// 体验订单排名信息getUserExperienceOrderRank
export const getUserExperienceOrderRank = (params)=>{return  req("get", "/manager/experience/getUserExperienceOrderRank", params)}

// 获取体验订单用户排名统计导出
export const getUserExperienceOrderRankExport = (params)=>{return  req("get", "/manager/experience/getUserExperienceOrderRankExport", params)}


// 体验订单汇总信息 getWithdrawalExperienceListStat
export const getWithdrawalExperienceListStat = (params)=>{return  req("get", "/manager/experience/getWithdrawalExperienceListStat", params)}

// 体验订单 getOrderListStat
export const getOrderListStat = (params)=>{return  req("get", "/manager/experience/getOrderListStat", params)}

// 获取体验订单详细信息
export const getExperienceOrderList = (params)=>{return  req("get", "/manager/experience/getOrderList", params)}

// 体验金提现初审
export const preauditWithdrawalExperience = (params)=>{return  req("get", "/manager/experience/preauditWithdrawalExperience", params)}

// 体验金提现复审
export const auditWithdrawalExperience = (params)=>{return  req("get", "/manager/experience/auditWithdrawalExperience", params)}

// 体验金提现到微信余额
export const transferExperienceMoneyToChange = (params)=>{return req("get", "/manager/experience/transferExperienceMoneyToChange", params)}

//打款体验利息到用户支付宝余额
export const payExperienceInterestToUserAliBalance = (params)=>{return req("get", "/manager/experience/payExperienceInterestToUserAliBalance", params)}

//打款体验利息到用户支付宝余额
export const payExperienceInterestToUserAliBalanceByPY = (params)=>{return req("get", "/manager/experience/payExperienceInterestToUserAliBalanceByPY", params)}


// 体验金提现到银行卡
export const transferExperienceMoneyToBank = (params)=>{return req("get", "/manager/experience/transferExperienceMoneyToBank", params)}

//编辑体验金手续费
export const editExperienceMoneyServiceCharge = (params)=>{return req("get", "/manager/experience/editExperienceMoneyServiceCharge", params)}




// 体验订单台账下载
// export const getExperienceOrderStandingBook = (params)=>{return  reqGet("/manager/experience/getExperienceOrderStandingBook", params)}

// 体验订单台账下载
export const getExperienceOrderStandingBook = (params)=>{return req("get",'/manager/experience/getExperienceOrderStandingBook',params)}

// 体验利息统计（3,7日）getExperienceMoneySta
export const getExperienceMoneySta = (params)=>{return  req("get","/manager/experience/getExperienceMoneySta", params)}

// 提现初审
export const preauditWithdrawal = (params)=>{return  req("get", "/manager/finance/preauditWithdrawal", params)}

// 提现复审
export const auditWithdrawal = (params)=>{return  req("get", "/manager/finance/auditWithdrawal", params)}

// 业务员提成明细导出

export const getUserMoneyListExport = (params)=>{return req("get",'/manager/finance/getUserMoneyListExport',params)}


// 体验金提现打款到微信
export const withdrawalToChange = (params)=>{return  req("get", "/manager/finance/withdrawalToChange", params)}

//业务员业绩提现到支付宝余额
export const withdrawToAlipayBalance = (params)=>{return  req("get", "/manager/finance/withdrawToAlipayBalance", params)}

// 样品确认回寄已收到
export const confirmSampleBack = (params)=>{return  req("get", "/manager/experience/confirmSampleBack", params)}

// 发货
export const bindExNoSendOrder= (params)=>{return  req("get", "/manager/order/bindExNoSendOrder", params)}

// 取消订单
export const closeOrder= (params)=>{return  req("get", "/manager/order/closeOrder", params)}

// 查看物流
export const getExpressinfondy = (params)=>{return  req("get", "/manager/order/getExpressinfondy", params)}

/**
 * 售后处理
 **/

// 售后查询
export const afterSaleApplyList =  (params)=>{return  req("get", "/manager/order/afterSaleApplyList", params)}

// 售后详情查询
export const getAfterSaleApplyDetailInfo =  (params)=>{return  req("get", "/manager/order/getAfterSaleApplyDetailInfo", params)}

// 同意售后申请
export const afterSaleConsentApply =  (params)=>{return  req("get", "/manager/order/afterSaleConsentApply", params)}

// 关闭售后申请
export const afterSaleCloseApply =  (params)=>{return  req("get", "/manager/order/afterSaleCloseApply", params)}

// 拒绝售后申请
export const afterSaleRejectApply =  (params)=>{return  req("get", "/manager/order/afterSaleRejectApply", params)}

// 售后查询           售后详情查询                  同意售后申请               关闭售后申请          拒绝售后申请
// afterSaleAppList , getAfterSaleApplyDetailInfo , afterSaleConsentApply , afterSaleCloseApply , afterSaleRejectApply


/**
 * 财务管理
 **/
// //编辑订金余额提现手续费
export const editWithdrawalDepositServiceChargeToUserBank = (params)=>{return req("get", "/manager/finance/editWithdrawalDepositServiceChargeToUserBank", params)}
//编辑订金余额提现手续费
export const editExperienceDepositServiceChargeToUserBank = (params)=>{return req("get", "/manager/experience/editExperienceDepositServiceChargeToUserBank", params)}
// 获取对账单
export const payAliBalance2Lei = (params)=>{ return req("get","/manager/finance/payAliBalance2Lei",params)}

// 提现记录
export const getWithdrawalList =  (params)=>{return  req("get", "/manager/finance/getWithdrawalList", params)}


//"体验本金提现记录-分页
export const getWithdrawalDepositList =  (params)=>{return  req("get", "/manager/finance/getWithdrawalDepositList", params)}

//"体验本金提现初审
export const getWithdrawalDepositListExport =  (params)=>{return  req("get", "/manager/finance/getWithdrawalDepositListExport", params)}

//"体验本金提现复审
export const auditWithdrawalDeposit =  (params)=>{return  req("get", "/manager/finance/auditWithdrawalDeposit", params)}


//"体验本金提现到支付宝余额
export const withdrawalDepositToAlipayBalance =  (params)=>{return  req("get", "/manager/finance/withdrawalDepositToAlipayBalance", params)}

//"体验本金提现到银行卡
export const withdrawalDepositToBank =  (params)=>{return  req("get", "/manager/finance/withdrawalDepositToBank", params)}

//"体验本金提现信息导出
export const preauditWithdrawalDeposit =  (params)=>{return  req("get", "/manager/finance/preauditWithdrawalDeposit", params)}

//"体验定金流水
export const getUserMoneyDepositList =  (params)=>{return  req("get", "/manager/finance/getUserMoneyDepositList", params)}

// 体验定金流水 导出getUserMoneyDepositListExport
export const getUserMoneyDepositListExport =  (params)=>{return  req("get", "/manager/finance/getUserMoneyDepositListExport", params)}


// 体验本金提现记录 getWithdrawalDepositList 体验本金提现初审 getWithdrawalDepositListExport 体验本金提现复审 auditWithdrawalDeposit
// 体验本金提现到支付宝余额 withdrawalDepositToAlipayBalance 体验本金提现到银行卡 withdrawalDepositToBank 体验本金提现信息导出 preauditWithdrawalDeposit

// 提现信息导出
// export const getWithdrawalListExport  = (params) => { return reqtext("get", "/manager/finance/getWithdrawalListExport", params) };

// export const getWithdrawalListExport  = (params) => {return reqGet( "/manager/finance/getWithdrawalListExport", params) };
// reqGet
// 奖金明细-
export const getUserMoneyList =  (params)=>{return  req("get", "/manager/finance/getUserMoneyList", params)}

// 平台流水-
export const getPayLogsList =  (params)=>{return  req("get", "/manager/finance/getPayLogsList", params)}


// 体验金提现记录
export const getWithdrawalExperienceList =  (params)=>{return  req("get", "/manager/experience/getWithdrawalExperienceList", params)}

//设置本金提现类型为用户设置
export const setDespositWithdrawTransferTypeByUserDefault =  (params)=>{return  req("get", "/manager/experience/setDespositWithdrawTransferTypeByUserDefault", params)}

// 体验金明细
export const getMoneyExperienceList =  (params)=>{return  req("get", "/manager/experience/getMoneyExperienceList", params)}

/**
 * *
 * 
 * 七年之痒
 * 
 **/
// 获取七年止痒订单-分页
export const getParterList =  (params)=>{return  req("get", "/manager/year7/getParterList", params)}

// 获取七年止痒订单-单个
export const getParterById =  (params)=>{return  req("get", "/manager/year7/getParterById", params)}

// 七年止痒返现
export const returnWaxsMoney =  (params)=>{return  req("get", "/manager/year7/returnWaxsMoney", params)}

// getCategoryYear7
export const getCategoryYear7 =  (params)=>{return  req("get", "/manager/year7/getCategoryYear7", params)}

// 导出excel
export const getParterListExport =  (params)=>{reqGet('/manager/year7/getParterListExport',params)}

// 导出excel 体验订单
export const getOrderListExport =  (params)=>{reqGet('/manager/experience/getOrderListExport',params)}
// 导出体验订单excel
export const getOrderListExportNew =  (params)=>{return req("get",'/manager/experience/getOrderListExport',params)}

// getUserExperiencePerformanceExport
export const getUserExperiencePerformanceExport =  (params)=>{return req("get",'/manager/experience/getUserExperiencePerformanceExport',params)}

// difwejsuifhjuefherhuiferhufherwhfuerhyfyhu普通订单导出测试
// export const orderListExport =  (params)=>{return reqtext("get",'/manager/order/getOrderListExport',params)}
export const orderListExport =  (params)=>{return req("get",'/manager/order/getOrderListExport',params)}
// export const orderListExport =  (params)=>{reqGet('/manager/order/getOrderListExport',params)}
/**
 * 优惠券接口
 **/
// 查看所有优惠券-
export const getAllCouponList =  (params)=>{return  req("get", "/manager/coupon/getAllCouponList", params)}

// 新增优惠券-
export const addEditCoupon =  (params)=>{return  tsreq("post", "/manager/coupon/addEditCoupon", params)}

// 删除优惠券-
export const deleteCoupon =  (params)=>{return  req("get", "/manager/coupon/deleteCoupon", params)}

// 用户优惠券记录-
export const getUserCouponList =  (params)=>{return  req("get", "/manager/coupon/getUserCouponList", params)}

// 删除用户优惠券 deleteUserCoupon
export const deleteUserCoupon =  (params)=>{return  req("get", "/manager/coupon/deleteUserCoupon", params)}

export const getUserMenu =  (params)=>{return  req("get", "/manager/coupon/deleteUserCoupon", params)}


// 用户登录
export const userLogin  = (params) => { return req("get", "/manager/admin/userLogin", params) };

export const userWXLogin  = (params) => { return req("get", "/manager/admin/userWXLogin", params) };

//修改当前用户密码
export const modifyPassword = (params) => { return req("get","/manager/admin/modifyPassword",params)}

// 活动记录 新增 addEditActivity
export const addEditActivity =  (params)=>{return  tsreq("post", "/manager/activity/addEditActivity", params)}

// 查询活动记录 
export const getActivityList =  (params)=>{return  req("get", "/manager/activity/getActivityList", params)}

// 查询所有活动记录 
export const getActivityAllList =  (params)=>{return  req("get", "/manager/activity/getActivityAllList", params)}

// 停止活动 
export const suspendActivity =  (params)=>{return  req("get", "/manager/activity/suspendActivity", params)}

// 恢复活动 
export const recoveryActivity =  (params)=>{return  req("get", "/manager/activity/recoveryActivity", params)}

// 获得单个活动详情 
export const getActivityById =  (params)=>{return  req("get", "/manager/activity/getActivityById", params)}



// 文件导出 reqtext
// 提现信息导出
// 导出excel
// 统一用这种方式
// export const getOrderListExport =  (params)=>{reqGet('/manager/experience/getOrderListExport',params)}
//体验金提现预存
export const  getExperiencePreStorage = (params) => {return req("get","/manager/experience/getExperiencePreStorage",params)}
export const  getExperiencePreStorageData = (params) => {return req("get","/manager/experience/getExperiencePreStorageData",params)}
//导出充值
export const getExperiencePreStorageDataExport = (params) => {return reqGet("/manager/experience/getExperiencePreStorageDataExport",params)}


//一键退款
export const getExperiencePreStorageRefund = (params) => {return req("get","/manager/experience/getExperiencePreStorageRefund",params)}
//单个退款
export const getExperienceRefund = (params) => {return req("get","/manager/experience/getExperienceRefund",params)}

//打款到银行卡
export const refundOffLine = (params) => {return req("get","/manager/experience/refundOffLine",params)}

//支付宝打款
export const alipayToUserAccount = (params) => {return req("get","/manager/experience/alipayToUserAccount",params)}
//体验本金提现预存查询统计
export const getExperiencePreStorageDataSta = (params) => {return req("get","/manager/experience/getExperiencePreStorageDataSta",params)}
// ceshi 
// api/story/createUserTag
export const createEditStory =  (params)=>{return  tsreq1("post", "/api/story/createEditStory", params)}
// export const addEditActivity =  (params)=>{return  tsreq("post", "/manager/activity/addEditActivity", params)}
//2021年9月26日18:08:49
//体验金本金提现-分页
export const getWithdrawalExperienceDepositList = (params) => {return req("get","/manager/experience/getWithdrawalExperienceDepositList",params)}
//打款体验本金提现到支付宝余额
export const payExperienceDepositToUserAliBalance = (params) => {return req("get","/manager/experience/payExperienceDepositToUserAliBalance",params)}


// 打款体验本金提现到支付宝余额(浏阳分公司) payExperienceDepositToUserAliBalanceByLY
export const payExperienceDepositToUserAliBalanceByLY =  (params)=>{return  req("get", "/manager/experience/payExperienceDepositToUserAliBalanceByLY", params)}
//打款体验本金提现到银行卡
export const payExperienceDepositToUserBank = (params) => {return req("get","/manager/experience/payExperienceDepositToUserBank",params)}
//体验本金提现预存查询统计
export const getWithdrawalExperienceDepositListSta = (params) => {return req("get","/manager/experience/getWithdrawalExperienceDepositListSta",params)}
//本金提现初审
export const preauditWithdrawalExperienceDeposit = (params) => {return req("get","/manager/experience/preauditWithdrawalExperienceDeposit",params)}
//本金提现复审
export const auditWithdrawalExperienceDeposit = (params) => {return req("get","/manager/experience/auditWithdrawalExperienceDeposit",params)}

//线下本金打款改状态
export const payExperienceDepositUnline = (params) => {return req("get","/manager/experience/payExperienceDepositUnline",params)}


///manager/goods/updateBatchGoodsPrice(cateMainId ,priceTypes,marketPrice,salePrice,vipPrice,specs,digits,mathType);
export const updateBatchGoodsPrice = (params)=>{return req("get","/manager/goods/updateBatchGoodsPrice",params)}
///manager/goods/updateOfficialGoodsPrice?cateMainId=1003
export const updateOfficialGoodsPrice = (params)=>{return req("get","/manager/goods/updateOfficialGoodsPrice",params)}
//manager/experience/getUserExperiencePerformance
export const getUserExperiencePerformance = (params)=>{return req("get","/manager/experience/getUserExperiencePerformance",params)}
//商品导出
// export const goodsQueryExport = (params)=>{reqGet("/manager/goods/goodsQueryExport",params)}

//体验商品销售统计http://192.168.0.147:8083/manager/order/ExperienceOrderVo
export const experienceOrderVo = (params)=>{return req("get","/manager/experience/ExperienceOrderVo",params)}


// 获取升级包列表
export const getUpgradeInfoList =  (params)=>{return req("get","/manager/upgrade/getUpgradeInfoList",params)}

// 保存升级信息 saveAppUpgrade
export const saveAppUpgrade =  (params)=>{return tsreq("post","/manager/upgrade/saveAppUpgrade",params)}


// 删除 deleteAppUpgrade
export const deleteAppUpgrade =  (params)=>{return req("get","/manager/upgrade/deleteAppUpgrade",params)}

//业务关系管理http://192.168.0.147:8083/manager/user/queryAllBusinessSubUser
export const queryAllBusinessSubUser = (params)=>{return req("get","/manager/user/queryAllBusinessSubUser",params)}
//查看完整修改记录 http://192.168.0.147:8083/manager/user/queryActivityUser?uid=61
export const queryActivityUser = (params)=>{return req("get","/manager/user/queryActivityUser",params)}
//修改激活用户限额   http://192.168.0.147:8083/manager/user/changeActivityUserCount?uid=61&countNum=3
export const changeActivityUserCount = (params)=>{return req("get","/manager/user/changeActivityUserCount",params)}

//获取体验商品
export const getExperienceGoods = (params)=>{return req("get","/manager/goods/getExperienceGoods",params)}
///manager/experience/getExperienceAgreement
export const getExperienceAgreement = (params)=>{ reqGet("/manager/experience/getExperienceAgreement",params)}



//导出用户列表
export const userListExport = (params)=>{ reqGet("/manager/user/userListExport",params)}

//设置奖品添加用户奖品 POST
export const addRewardGoods = (params)=>{ return tsreq("post","/manager/point/addRewardGoods",params)}

//初始化周期奖品
export const initRewardGoods = (params)=>{ return req("get","/manager/point/initRewardGoods",params)}

//编辑奖品
export const editRewardGoods = (params)=>{ return tsreq("post","/manager/point/editRewardGoods",params)}

// 获取活动开始时间 getPointActivityStartTime
export const getPointActivityStartTime = (params)=>{ return req("get","/manager/point/getPointActivityStartTime",params)}

// 设置活动开始时间 getPointActivityStartTime
export const setPointActivityStartTime = (params)=>{ return req("get","/manager/point/setPointActivityStartTime",params)}


// initRewardGoods ,editRewardGoods,getPointActivityStartTime,setPointActivityStartTime

//获取奖品
export const getRewardGoods = (params)=>{ return req("get","/manager/point/getRewardGoods",params)}

//删除奖品
export const delRewardGoods = (params)=>{ return req("get","/manager/point/delRewardGoods",params)}
//颁奖addAllUserReward 
export const addAllUserReward = (params)=>{ return req("get","/manager/point/addAllUserReward",params)}
//设置假用户积分 addFalsePoint?userName=xx&pointAmount=1200
export const addFalsePoint = (params)=>{ return req("get","/manager/point/addFalsePoint",params)}
//删除用户积分
export const delPoint = (params)=>{ return req("get","/manager/point/delPoint",params)}
//获取用户积分
export const getUserPoint = (params)=>{ return req("get","/manager/point/getUserPoint",params)}

//获取业务员
export const getBusinessUser = (params)=>{ return req("get","/manager/point/getBusinessUser",params)}


//获取用户，给用户加积分，此处暂给在职业务员加假积分
export const addFictitiousPoint = (params)=>{ return req("get","/manager/point/addFictitiousPoint",params)}

// getAllUserRanks
//获取用户积分排行
export const getAllUserRanks = (params)=>{ return req("get","/manager/point/getAllUserRanks",params)}

//颁奖addAllUserReward 
export const setAward = (params)=>{ return req("get","/manager/point/setAward",params)}

//获取新闻
export const getAllNews = (params)=>{ return req("get","/manager/website/getAllNews",params)}
//设置新闻 POST
export const addAmendNews = (params)=>{ return tsreq("post","/manager/website/addAmendNews",params)}
//删除新闻
export const delNewsById = (params)=>{ return req("get","/manager/website/delNewsById",params)}

//添加积分兑换商品
export const addPointsGoods = (params)=>{ return tsreq("post","/manager/point/addPointsGoods",params)}
//删除积分兑换商品 GET192.168.0.147:8087/manager/point/delPointsGoods?goodsId=9
export const delPointsGoods = (params)=>{ return req("get","/manager/point/delPointsGoods",params)}
//查询积分商品 GET192.168.0.147:8087/manager/point/getPointsGoods
export const getPointsGoods = (params)=>{ return req("get","/manager/point/getPointsGoods",params)}

//查询积分订单
export const getAllPointsOrder = (params)=>{ return req("get","/manager/point/getAllPointsOrder",params)}

//初始化店铺投资配置 GEThttp://192.168.0.147:8087/manager/investment/initializeWarehouseAndInvestment
export const initializeWarehouseAndInvestment = (params)=>{ return req("get","/manager/investment/initializeWarehouseAndInvestment",params)}
//查询店铺投资配置 
export const getWarehouseAndInvestment = (params)=>{ return req("get","/manager/investment/getWarehouseAndInvestment",params)}
//修改店铺投资配置 POST
export const updateWarehouseAndInvestment = (params)=>{ return tsreq("post","/manager/investment/updateWarehouseAndInvestment",params)}


//投资人认购初审 
export const investmentAuditPre = (params)=>{ return req("get","/manager/investment/investmentAuditPre",params)}
//投资人认购复审 
export const investmentAuditRe = (params)=>{ return req("get","/manager/investment/investmentAuditRe",params)}
//投资人认购查询 GET
export const getUserAndInvestment = (params)=>{ return req("get","/manager/investment/getUserAndInvestment",params)}
//提现查询
export const getUserAndReceive = (params)=>{ return req("get","/manager/investment/getUserAndReceive",params)}
//投资人提现初审 
export const investmentReceive = (params)=>{ return req("get","/manager/investment/investmentReceive",params)}
//投资人提现复审
export const receiveAuditRe = (params)=>{ return req("get","/manager/investment/receiveAuditRe",params)}
//上传协议图片 GET
export const updateAgreementImg = (params)=>{ return req("get","/manager/investment/updateAgreementImg",params)}



//日志查詢
// 用户操作日志
export const getUserOperLog = (params)=>{ return req("get","/manager/log/getUserOperLog",params)}

// 体验商品更改日志
export const getExperienceGoodsModifyLog = (params)=>{ return req("get","/manager/log/getExperienceGoodsModifyLog",params)}

// 商品更改日志
export const getGoodsModifyLog = (params)=>{ return req("get","/manager/log/getGoodsModifyLog",params)}

// 获取对账单
export const getAccountBill = (params)=>{ return req("get","/manager/experience/getAccountBill",params)}

//订金余额提现拆分记录
export const getWithdrawalDepositSplitList = (params)=>{
	return req("get","/manager/finance/getWithdrawalDepositSplitList",params)
}




// 债券相关
export const getAllCity = (params)=>{ return req("get","/manager/bond/getAllCity",params)}
export const getManageCity = (params)=>{ return req("get","/manager/bond/getManageCity",params)}
export const getAllBuyBackCodes = (params)=>{ return req("get","/manager/bond/getAllBuyBackCodes",params)}


export const addEditBondBase = (params)=>{ return tsreq("post","/manager/bond/addEditBondBase",params)}
export const delBondBase = (params)=>{ return req("get","/manager/bond/delBondBase",params)}
export const getBondList = (params)=>{ return req("get","/manager/bond/getBondList",params)}
export const getBondCashFlowList = (params)=>{ return req("get","/manager/bond/getBondCashFlowList",params)}
export const getBondBaseById = (params)=>{ return req("get","/manager/bond/getBondBaseById",params)}

export const addEditCityPositon = (params)=>{ return tsreq("post","/manager/bond/addEditCityPositon",params)}
export const delCityPositon = (params)=>{ return req("get","/manager/bond/delCityPositon",params)}
export const getCityPositonList = (params)=>{ return req("get","/manager/bond/getCityPositonList",params)}

export const getBondHoldAnalysis = (params)=>{ return req("get","/manager/bond/getBondHoldAnalysis",params)}
export const getBondHoldAnalysisList = (params)=>{ return req("get","/manager/bond/getBondHoldAnalysisList",params)}
export const getBondHoldAnalysisListExport = (params)=>{ return req("get","/manager/bond/getBondHoldAnalysisListExport",params)}

export const getAllBuyBonds = (params)=>{ return req("get","/manager/bond/getAllBuyBonds",params)}
export const getValutionZhongZhai = (params)=>{ return req("get","/manager/bond/getValutionZhongZhai",params)}
export const addEditBondValutionZhongzhai = (params)=>{ return tsreq("post","/manager/bond/addEditBondValutionZhongzhai",params)}
export const delBondValutionZhongzhai = (params)=>{ return req("get","/manager/bond/delBondValutionZhongzhai",params)}

export const getMyYieldList = (params)=>{ return req("get","/manager/bond/getMyYieldList",params)}
export const getMyYieldListAll = (params)=>{ return req("get","/manager/bond/getMyYieldListAll",params)}
export const dayYieldListExport = (params)=>{return  req("get", "/manager/bond/dayYieldListExport", params)}

export const addEditCityHold = (params)=>{ return tsreq("post","/manager/bond/addEditCityHold",params)}
export const delCityCityHold = (params)=>{ return req("get","/manager/bond/delCityHold",params)}
export const getCityHold = (params)=>{ return req("get","/manager/bond/getCityHold",params)}

export const addEditBuyBack = (params)=>{ return tsreq("post","/manager/bond/addEditBuyBack",params)}
export const delBuyBack = (params)=>{ return req("get","/manager/bond/delBuyBack",params)}
export const getBuyBackList = (params)=>{ return req("get","/manager/bond/getBuyBackList",params)}
export const getBuyBackListSta = (params)=>{ return req("get","/manager/bond/getBuyBackListSta",params)}
export const getBuyBackListExport = (params)=>{ return req("get","/manager/bond/getBuyBackListExport",params)}


export const getBuyBackQuote = (params)=>{ return req("get","/manager/bond/getBuyBackQuote",params)}
export const addEditBuyBackQuote = (params)=>{ return tsreq("post","/manager/bond/addEditBuyBackQuote",params)}
export const delBuyBackQuote = (params)=>{ return req("get","/manager/bond/delBuyBackQuote",params)}


export const getWeekReport = (params)=>{ return req("get","/manager/bond/getWeekReport",params)}
export const generateWord = (params)=>{ return req("get","/manager/bond/generateWord",params)}



export const getFuturesQuote1K = (params)=>{ return req("get","/manager/investment/getFuturesQuote1K",params)}
export const getFuturesQuote5K = (params)=>{ return req("get","/manager/investment/getFuturesQuote5K",params)}

export const getAllFutureCodes = (params)=>{ return req("get","/manager/investment/getAllFutureCodes",params)}
export const getAllFutureTypes = (params)=>{ return req("get","/manager/investment/getAllFutureTypes",params)}
export const getFuturesQuote = (params)=>{ return req("get","/manager/investment/getFuturesQuote",params)}

export const getAllNewsTypes = (params)=>{ return req("get","/manager/content/getAllNewsTypes",params)}
export const getNewsReports = (params)=>{ return req("get","/manager/content/getNewsReports",params)}
export const addEditNewsReport = (params)=>{ return tsreq("post","/manager/content/addEditNewsReport",params)}
export const delNewsReport = (params)=>{ return req("get","/manager/content/delNewsReport",params)}

export const getBondQuotedPrice = (params)=>{ return req("get","/manager/bond/getBondQuotedPrice",params)}
export const addEditBondQuotedPrice = (params)=>{ return tsreq("post","/manager/bond/addEditBondQuotedPrice",params)}
export const delBondQuotedPrice = (params)=>{ return req("get","/manager/bond/delBondQuotedPrice",params)}

export const getStrategicCommunication = (params)=>{ return req("get","/manager/bond/getStrategicCommunication",params)}
export const addEditStrategicCommunication = (params)=>{ return tsreq("post","/manager/bond/addEditStrategicCommunication",params)}
export const delStrategicCommunication = (params)=>{ return req("get","/manager/bond/delStrategicCommunication",params)}

export const updateDayYield = (params)=>{ return req("get","/manager/bond/updateDayYield",params)}
export const updateBuyBackTransction = (params)=>{ return req("get","/manager/bond/updateBuyBackTransction",params)}
export const updateBondHold = (params)=>{ return req("get","/manager/bond/updateBondHold",params)}


export const getContracts = (params)=>{ return req("get","/manager/content/getContracts",params)}
export const addEditContract = (params)=>{ return tsreq("post","/manager/content/addEditContract",params)}
export const delContract = (params)=>{ return req("get","/manager/content/delContract",params)}

export const getContractTemplates = (params)=>{ return req("get","/manager/content/getContractTemplates",params)}
export const addEditContractTemplate = (params)=>{ return tsreq("post","/manager/content/addEditContractTemplate",params)}
export const delContractTemplate = (params)=>{ return req("get","/manager/content/delContractTemplate",params)}

export const getMarketPromotionalMaterials = (params)=>{ return req("get","/manager/content/getMarketPromotionalMaterials",params)}
export const addEditMarketPromotionalMaterial = (params)=>{ return tsreq("post","/manager/content/addEditMarketPromotionalMaterial",params)}
export const delMarketPromotionalMaterial = (params)=>{ return req("get","/manager/content/delMarketPromotionalMaterial",params)}

export const getTransactionAccounts = (params)=>{ return req("get","/manager/transaction/getTransactionAccounts",params)}
export const getTransactionAccountLevel1 = (params)=>{ return req("get","/manager/transaction/getTransactionAccountLevel1",params)}

export const getAllTransactionAccounts = (params)=>{ return req("get","/manager/transaction/getAllTransactionAccounts",params)}

export const addEditTransactionAccount = (params)=>{ return tsreq("post","/manager/transaction/addEditTransactionAccount",params)}
export const delTransactionAccount = (params)=>{ return req("get","/manager/transaction/delTransactionAccount",params)}



export const getTransactionMaintenances = (params)=>{ return req("get","/manager/transaction/getTransactionMaintenances",params)}
export const getTransactionMaintenancesAll = (params)=>{ return req("get","/manager/transaction/getTransactionMaintenancesAll",params)}
export const addEditTransactionMaintenance = (params)=>{ return tsreq("post","/manager/transaction/addEditTransactionMaintenance",params)}
export const importTransactionMaintenance = (params)=>{ return tsreq("post","/manager/transaction/importTransactionMaintenance",params)}
export const delTransactionMaintenance = (params)=>{ return req("get","/manager/transaction/delTransactionMaintenance",params)}



export const getBondFuturesTradingList = (params)=>{ return req("get","/manager/quantization/getBondFuturesTradingList",params)}
export const addEditBondFuturesTrading = (params)=>{ return tsreq("post","/manager/quantization/addEditBondFuturesTrading",params)}
export const delBondFuturesTrading= (params)=>{ return req("get","/manager/quantization/delBondFuturesTrading",params)}

export const addEditBondFuturesTradingRecord = (params)=>{ return tsreq("post","/manager/quantization/addEditBondFuturesTradingRecord",params)}
export const delBondFuturesTradingRecord= (params)=>{ return req("get","/manager/quantization/delBondFuturesTradingRecord",params)}

export const getFuturesQuotes = (params)=>{ return req("get","/manager/quantization/getFuturesQuotes",params)}

export const startmoxing = (params)=>{ return req("get","/manager/system/startmoxing",params)}



export const getBondCateList = (params)=>{ return req("get","/manager/bonddb/getBondCateList",params)}
export const addEditBondCate = (params)=>{ return tsreq("post","/manager/bonddb/addEditBondCate",params)}
export const delBondCate= (params)=>{ return req("get","/manager/bonddb/delBondCate",params)}
export const getBondCateLevel1All= (params)=>{ return req("get","/manager/bonddb/getBondCateLevel1All",params)}
export const getBondCateLevel2By1= (params)=>{ return req("get","/manager/bonddb/getBondCateLevel2By1",params)}


export const getAllBonds= (params)=>{ return req("get","/manager/bond/getAllBonds",params)}


export const getTraderAll = (params)=>{ return req("get","/manager/bonddb/getTraderAll",params)}
export const getTraderList = (params)=>{ return req("get","/manager/bonddb/getTraderList",params)}
export const addEditTrader = (params)=>{ return tsreq("post","/manager/bonddb/addEditTrader",params)}
export const delTrader= (params)=>{ return req("get","/manager/bonddb/delTrader",params)}

export const getTradingQuotationList = (params)=>{ return req("get","/manager/bonddb/getTradingQuotationList",params)}
export const addEditTradingQuotation = (params)=>{ return tsreq("post","/manager/bonddb/addEditTradingQuotation",params)}
export const delTradingQuotation= (params)=>{ return req("get","/manager/bonddb/delTradingQuotation",params)}

export const getBondTickList = (params)=>{ return req("get","/manager/bonddb/getBondTickList",params)}
export const addEditBondTick = (params)=>{ return tsreq("post","/manager/bonddb/addEditBondTick",params)}
export const delBondTick= (params)=>{ return req("get","/manager/bonddb/delBondTick",params)}


export const getAllQuoteTypes = (params)=>{ return req("get","/manager/bonddb/getAllQuoteTypes",params)}
export const getBondQuoteList = (params)=>{ return req("get","/manager/bonddb/getBondQuoteList",params)}


export const getBondYieldCurveNameAll = (params)=>{ return req("get","/manager/bonddb/getBondYieldCurveNameAll",params)}
export const getBondYieldCurveAll = (params)=>{ return req("get","/manager/bonddb/getBondYieldCurveAll",params)}
export const getBondYieldCurveList = (params)=>{ return req("get","/manager/bonddb/getBondYieldCurveList",params)}

export const getFuturesQuoteTLIHL = (params)=>{ return req("get","/manager/quantization/getFuturesQuoteTLIHL",params)}
export const getDateMsg = (params)=>{ return req("get","/manager/quantization/getDateMsg",params)}


export const getBondReviews = (params)=>{ return req("get","/manager/quantization/getBondReviews",params)}
export const addEditBondReview = (params)=>{ return tsreq("post","/manager/quantization/addEditBondReview",params)}
export const delBondReview = (params)=>{ return req("get","/manager/quantization/delBondReview",params)}
export const getBaseSubAnalysis = (params)=>{ return req("get","/manager/quantization/getBaseSubAnalysis",params)}
export const getBaseSubAnalysisZLGQ = (params)=>{ return req("get","/manager/quantization/getBaseSubAnalysisZLGQ",params)}



export const getAllSpotCodes = (params)=>{ return req("get","/manager/investment/getAllSpotCodes",params)}
